<template>
  <ipub-model title="Reason for Reject Application"
              width="400px"
              :visable="isVisable"
              confirmText="Reject"
              confirmType="theme"
              @confirm="confirm"
              @cancel="cancel">
    <div class="ipub-p3 mar-b-4">Please be aware that this reason will be shown on Reviwer's page.</div>
    <ipub-form ref="reject-reason-form"
               :model="params"
               :rules="rules">
      <ipub-form-item prop="content">
        <ipub-textarea placeholder="Please explain your reject reason in detail…"
                       v-model.trim="params.content" />
      </ipub-form-item>
    </ipub-form>
  </ipub-model>
</template>

<script>
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {
        content: ''
      },
      rules: {
        content: [
          {
            max: 1000,
            message: `Reject Reason length must not be more than 1000 digits`
          }
        ]
      }
    }
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          content: ''
        }
      }
    },
  },
  methods: {
    confirm () {
      const flag = this.$refs['reject-reason-form'].validate()
      flag && this.$emit('confirm', this.params.content, this.inputData.id)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>
